import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { PageResponse } from '@core/entities/pagination'
import { AssignableProject, IAssignableProject } from '@core/entities/company'
import { usePageableQuery } from '@core/react-query/hooks'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

const dataTransformer = (response: PageResponse<IAssignableProject>) => {
  return {
    ...response,
    content: response.content.map((project) => AssignableProject.new(project)),
  }
}

export const useGetAssignableProjects = (
  payload: RequestTypes['getAssignableProjects'],
  options?: UseInfiniteQueryOptions<
    PageResponse<IAssignableProject>,
    RequestErrorType,
    PageResponse<AssignableProject>
  >,
) => {
  const assignableProjectsQuery = companyKeys.getAssignableProjects(payload)
  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options?.enabled,
    queryKey: assignableProjectsQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<IAssignableProject>,
    RequestErrorType,
    PageResponse<AssignableProject>
  >({
    ...infiniteQueryOptions,
    ...assignableProjectsQuery,
    ...options,
  })
}
